import React, { useState, useEffect } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { Button } from '../../../components'
import { useMessage } from '../../../hooks'
import { clientCaseService } from '../services'
import { appName } from '../appConfig'
import config from '../../../config'
import '../index.css'

const ClientCasePreview = () => {
  const navigate   = useNavigate()
  const { slug }   = useParams()
  const { showMessage } = useMessage()
  const [clientCase, setClientCase] = useState(null)
  const [loading, setLoading]       = useState(true)

  useEffect(() => {
    const ctrl = new AbortController()
    clientCaseService.getBySlug(slug, ctrl.signal)
      .then(res => { setClientCase(res.clientCase); setLoading(false) })
      .catch(err => { if (err.name !== 'AbortError') { showMessage('Kunde inte ladda kundcase', 'error'); setLoading(false) } })
    return () => ctrl.abort()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [slug])

  if (loading) return <div className="cc-page"><p style={{ color: 'var(--color-dark-grey)' }}>Laddar…</p></div>

  const clientName = clientCase?.client_name || slug
  const clientSlug = clientCase?.client_slug
  const uuid       = clientCase?.client_case_uuid
  const htmlUrl    = uuid ? `${config.api.url}/${appName}/clientCase/${uuid}/html` : null

  return (
    <div className="cc-preview-page">
      <div className="cc-preview-header">
        <div className="cc-preview-header-inner">
          {clientSlug && <Button value="← Kund" className="button" onClick={() => navigate(`/${appName}/${clientSlug}`)} />}
          <Button value="Redigera" className="button" onClick={() => navigate(`/${appName}/cases/${slug}/edit`)} />
          {clientSlug && <Button value="Utvärderingar" className="button" onClick={() => navigate(`/${appName}/${clientSlug}/reviews`)} />}
        </div>
      </div>
      {htmlUrl
        ? <iframe className="cc-preview-frame" src={htmlUrl} title={`Förhandsvisning — ${clientName}`} />
        : <div className="cc-page" style={{ paddingTop: 40 }}>
            <div style={{ color: 'var(--color-dark-grey)', fontStyle: 'italic', display: 'flex', alignItems: 'center', gap: 8 }}>
              <span>Ingen infografik genererad ännu.</span>
              <Button value="Öppna redigeraren för att generera" className="button" onClick={() => navigate(`/${appName}/cases/${slug}/edit`)} />
            </div>
          </div>
      }
    </div>
  )
}

export default ClientCasePreview
